import React from "react";
import Button from "components/UiComponents/Button";
import { MdSave } from "react-icons/md";
import styles from "./StepSummary.module.scss";

const StepSummary = ({ userData, onPrev, onSave }) => {

    const handleSave = () => {
        // Mettre à jour les données finales avec timestamp
        const finalData = {
            ...userData,
            createdAt: new Date().toISOString(),
            isValid: true
        };

        console.log("Données à sauvegarder:", finalData);
        onSave(finalData);
    };

    return (
        <div className={styles.container}>
            <div className={styles.summary}>
                <p><span className={styles.label}>Login:</span> <span className={styles.value}>{userData.login}</span></p>
                <p><span className={styles.label}>Email:</span> <span className={styles.value}>{userData.email}</span></p>
                <p><span className={styles.label}>Nom:</span> <span className={styles.value}>{userData.lastName}</span></p>
                <p><span className={styles.label}>Prénom:</span> <span className={styles.value}>{userData.name}</span></p>
                <p><span className={styles.label}>Mot de passe:</span> <span className={styles.value}>{"*".repeat(userData.password?.length || 0)}</span></p>
                <p></p>
                <p><span className={styles.label}>Libellé Abonnement:</span> <span className={styles.value}>{userData.subscription}</span></p>
                <p><span className={styles.label}>N° Odoo:</span> <span className={styles.value}>{userData.subid}</span></p>
                <p><span className={styles.label}>Type Abonnement:</span> <span className={styles.value}>{userData.plan}</span></p>
                <p></p>
                <p><span className={styles.label}>Nom cabine:</span> <span className={styles.value}>{userData.cabine}</span></p>
                <p><span className={styles.label}>Type cabine:</span> <span className={styles.value}>{userData.typeCabine}</span></p>
            </div>



            <div className={styles.actionButtons}>

                <Button
                    type="button"
                    onPress={handleSave}
                    text="Sauvegarder"
                    svg={<MdSave />}
                    styles={"btnPrimary"}
                />
            </div>
        </div>
    );
};

export default StepSummary;
